import upperFirst from 'lodash/upperFirst'
import { compose, lifecycle, setDisplayName } from 'recompose'
import withStatus from 'hocs/bases/withStatus'
import withSnackBar from 'store/snackbar/withSnackBar'

const withCreateResource = ({
  resourceName = 'resource',
  getAction = () => Promise.resolve,
  getSuccessMessage,
  getFailureMessage,
  getOnSuccess,
}) => {
  const ResourceName = upperFirst(resourceName)
  return compose(
    setDisplayName(`With Create ${ResourceName}`),
    withSnackBar,
    withStatus({
      actionName: `create${ResourceName}`,
      statusName: `create${ResourceName}Status`,
      getAction,
      getOnRequest: (props) => () => props.showMessage({ message: null }),
      getSuccessMessage: getSuccessMessage || (() => `${ResourceName} has been created.`),
      getFailureMessage: getFailureMessage || (() => `Create ${ResourceName} fail.`),
      getOnSuccess, // for redirect to view all page
    }),
    lifecycle({
      componentWillReceiveProps(nextProps, nextContext) {
        const { [`create${ResourceName}Status`]: nextCreateStatus } = nextProps
        const { [`create${ResourceName}Status`]: createStatus } = this.props
        if (
          createStatus.isRequest &&
          (
            nextCreateStatus.isSuccess ||
            nextCreateStatus.isFailure
          )
        ) {
          this.props.showMessage({ message: nextCreateStatus.message })
        }
      },
    }),
  )
}

export default withCreateResource


// WEBPACK FOOTER //
// ./src/hocs/bases/withCreateResource.js